module.exports = __webpack_public_path__ + "static/img/59d2a1cb26c0831d (1).f3365beb.png";